<style>
  @import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
  -webkit-print-color-adjust: exact !important; /* Chrome, Safari, Edge */
  color-adjust: exact !important; /*Firefox*/
  body {
    width: 230mm !important;
    height: 100% !important;
    margin: 0 auto !important;
    padding: 0 !important;
    font-size: 12pt !important;
  }
  * {
    box-sizing: border-box !important;
    -moz-box-sizing: border-box !important;
  }
  .main-page {
    width: 210mm;
    min-height: 297mm;
    margin: 10mm auto;
    background: rgb(129, 56, 56);
    box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  }

  .sub-page {
    padding: 1cm;
    height: 297mm;
    background: white;
  }
  @page {
    size: A4 !important;
    margin: 0 !important;
  }
  @media print {
    html,
    body {
      width: 210mm !important;
      height: 297mm !important;
    }
    .main-page {
      margin: 0;
      border: initial;
      border-radius: initial;
      width: initial;
      min-height: initial;
      box-shadow: initial;
      background: initial;
      page-break-after: always;
    }
    .no-print {
      display: none !important;
    }

  }
</style>

<!-- START PORTADA    -->
<div style="position: absolute; top: 25px; right: 25px" class="no-print ">
  <a class="btn btn-secondary mr-2" style="color: #fff" [routerLink]="['/student/settings/index']"><strong >VOLVER</strong></a>
  <a class="btn btn-primary" style="color: #fff" onclick="window.print();"><strong>IMPRIMIR / DESCARGAR</strong></a>
</div>


<script>
  /* window.print();*/
</script>
<div class="main-page">
  <div class="sub-page" style="padding: 0">
    <table width="100%" >
      <tr>
        <td><img style="width: 250px; margin-top: 1cm; margin-left: 1.5cm" src="assets/img/logo.svg" /></td>
      </tr>
      <tr>
        <td style="width: 50%">
          <div style="margin-top: 1cm; margin-left: 1.5cm">            
            <p>
              <strong>Wordiix Sociedad Limitada</strong><br />
              Calle Algaira 2A <br />
              Requena, Valencia CP:46340 <br />
              soporte@wordiix.com<br />
              B02751204
            </p>
          </div>
        </td>
        <td style="width: 50%" valign="top">
          <div style="margin-top: 1cm; margin-right: 1.5cm; text-align: end;">
            <h2 class="primary">Nº DE RECIBO</h2>
            <p>{{ invoiceData.id }}</p>
            <h2 class="primary">FECHA</h2>
            <p>{{ invoiceData.created_at | date:'dd/MM/YYYY' }}</p>
            
          </div>
        </td>
      </tr>
    </table>

    <table width="100%">
        <tr>
          <td style="width: 35%">
            <div style="margin-top: 1cm; margin-left: 1.5cm;">
              <h1 style="margin-bottom: 0.5cm;">DATOS:</h1>
              <p>Fecha: <strong>{{ invoiceData.created_at | date:'dd/MM/YYYY' }}</strong></p>
              <p>Hora: <strong>{{ invoiceData.created_at | date:'shortTime' }}</strong></p>
              <p>Método de pago: <strong>{{ invoiceData.movement_platform }}</strong></p>
            </div>
          </td>
          <td style="width: 65%">
            <div style="margin-top: 1cm; margin-left: 1.5cm;">
              <h1 style="margin-bottom: 0.5cm;">DATOS CLIENTE:</h1>
              <p><strong>{{ invoiceData.user.fullName }}</strong></p>             
              <p>Telf: <strong>{{ invoiceData.user.phone }}</strong></p>
               <p> Email: <strong>{{ invoiceData.user.email }}</strong>
              </p>
            </div>
          </td>
        </tr>
    </table>
<div style="margin-top: 2cm; margin-left: 1.5cm; margin-right: 1.5cm;">
    <table width="100%">
      <thead>
      <tr style="border-bottom: 4px solid #e2e2e2; ">
        <td style="width: 60%;padding-bottom:0.3cm"><strong>Profesor</strong></td>
        <td style="width: 20%; text-align: center;padding-bottom:0.3cm"><strong>Cantidad</strong></td>
        <td style="width: 20%; text-align: end;padding-bottom:0.3cm"><strong>Precios</strong></td>
      </tr>
    </thead>
    <tbody>
      <tr style="border-bottom: 2px solid #7e7e7e; padding: 10px;">
        <td style="padding-top: 0.5cm; padding-bottom: 0.5cm;">
          {{ invoiceData.other_user.fullName }}
        </td>
        <td style="text-align: center;">
          {{ invoiceData.quantity_hours }} h.
        </td>
        <td style="padding-top: 0.5cm; text-align: end; padding-bottom: 0.5cm;">
          {{ invoiceData.price | currency:'EUR':true }}
        </td>
      </tr>
      
    </tbody>
    <tfoot>
      <tr style="background-color: #e2e2e2;">
        <td style="padding-top: 0.5cm; padding-bottom: 0.5cm; ">
           <strong> TOTAL:</strong><br>
           <span class="small">Comisión pasarela de pago incluida: {{ invoiceData.business_commission.commision_price | currency:'EUR':true }}</span>

        </td>
        <td class="small"></td>
        <td style="padding-top: 0.5cm; text-align: end;padding-bottom: 0.5cm; ">
           <strong> {{ invoiceData.price | currency:'EUR':true }}</strong>
          
        </td>
      </tr>
    </tfoot>
    </table>
    <p style="margin-top: 1cm;"></p>
  </div>
  </div>
</div>
<!-- END PORTADA    -->
